export default "__VITE_ASSET__241c84e5__"